import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { createNamedContext } from "../createNamedContext";
import { FilterablePubSub } from "./filterablePubSub";
const warnOnlyInDevAndTest = (text) => {
    if (!["prod", "uat"].includes(process.env.DEPLOY_ENV))
        console.warn(text);
};
export const UserInteractionContext = createNamedContext("UserInteractionContext", {
    publish: (...args) => warnOnlyInDevAndTest(`Attempt to publish User Interaction outside of UserInteractionContext: ${JSON.stringify(args)}`),
    subscribe: (filter, _) => warnOnlyInDevAndTest(`Attempt to subscribe to User Interaction outside of UserInteractionContext: ${filter}`),
    unsubscribe: (_) => warnOnlyInDevAndTest("Attempt to unsubscribe to User Interaction outside of UserInteractionContext"),
});
export const UserInteractionContextProvider = ({ children, }) => {
    const [filterablePubSubRef] = useState(() => new FilterablePubSub());
    const value = useMemo(() => ({
        publish: (topic, args) => filterablePubSubRef.publish(topic, args),
        subscribe: (filter, callback) => filterablePubSubRef.subscribe(filter, callback),
        unsubscribe: (callback) => filterablePubSubRef.unsubscribe(callback),
    }), [filterablePubSubRef]);
    return _jsx(UserInteractionContext.Provider, { value: value, children: children });
};
